"use client";

import { useLingui } from "@lingui/react/macro";
import { LicensePlate } from "@offstreetparking/design-system/dataDisplay/LicensePlate";
import { Text } from "@offstreetparking/design-system/typography";
import type { ParkerVehicle } from "./parker-vehicle";

type VehicleLabelProps = {
	vehicle: ParkerVehicle;
};

export const VehicleLabel = ({ vehicle }: VehicleLabelProps) => {
	const { t } = useLingui();
	return (
		<>
			<LicensePlate plate={vehicle.plate} state={vehicle.state} className="shrink-0" />
			<div className="min-w-0 flex-1">
				<Text As="p" weight="medium" className="truncate">
					{vehicle.nickname || t`Untitled Vehicle`}
				</Text>
				{vehicle.isDefault && (
					<Text intent="muted" className="truncate">
						{t`(Default)`}
					</Text>
				)}
			</div>
		</>
	);
};
